// Globals
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

// Store
import { useAppState } from '@/store';

// Modules
import { Header } from '@/modules/Layout';
import { selectChannel } from '@/modules/Channels';

//Components
import { Spinner } from '@/ui';
import { PaymentMethodsTable } from '../../components';
import { StyledContainer } from './PaymentMethodsContainerStyles';

// Helpers
import { useGetPaymentMethods } from '../../hooks';

const PaymentMethodsContainer: FC = () => {
  const { t } = useTranslation(['common']);
  const currentChannel = useAppState(selectChannel);

  const { paymentMethods, isLoading } = useGetPaymentMethods(currentChannel?.id);

  return (
    <>
      <Header title={t('menu_payment_methods')} suptitle={t('menu_website_management')} />
      <StyledContainer>
        <Spinner spinning={false}>
          <PaymentMethodsTable paymentMethods={paymentMethods} isLoading={isLoading} />
        </Spinner>
      </StyledContainer>
    </>
  );
};

export default PaymentMethodsContainer;
